// src/pages/HomePage/HomePage.jsx
import React from 'react';
import SEOHelmet from '../../../src/components/SEO/SEOHelmet'; // шлях з урахуванням твоєї структури

import AboutUs from '../../components/home/AboutUs/AboutUs';
import BackLinks from '../../components/home/BackLinks/BackLinks';
import ContactUs from '../../components/home/ContactUs/ContactUs';
import GoogleMap from '../../components/home/GoogleMap/GoogleMap';
import HeroSection from '../../components/home/HeroSection/HeroSection';
import Projects from '../../components/home/Projects/Projects';
import Services from '../../components/home/Services/Services';

import styles from './HomePage.module.css';

export default function HomePage() {
  return (
    <>
      {/* Весь SEO для головної тут */}
      <SEOHelmet pageKey="home" />

      <div className={styles.homePage}>
        <HeroSection />
        <AboutUs />
        <Services />
        <Projects />
        <ContactUs />
        <BackLinks />
        <GoogleMap />
      </div>
    </>
  );
}
